const ZoomOut = ({
  className = "stroke-ctb-blue-400"
}: {
  className?: string;
}) => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.0854 19.0017L14.3902 13.0236M12.1585 8.04185H5.46341M16.622 8.04185C16.622 8.95775 16.4199 9.86469 16.0274 10.7109C15.6348 11.557 15.0595 12.3259 14.3342 12.9735C13.6089 13.6212 12.7478 14.1349 11.8001 14.4854C10.8524 14.8359 9.83673 15.0163 8.81098 15.0163C7.78522 15.0163 6.76952 14.8359 5.82184 14.4854C4.87417 14.1349 4.0131 13.6212 3.28778 12.9735C2.56247 12.3259 1.98711 11.557 1.59458 10.7109C1.20204 9.86469 1 8.95775 1 8.04185C1 6.19211 1.82294 4.41812 3.28778 3.11016C4.75262 1.80219 6.73938 1.06738 8.81098 1.06738C10.8826 1.06738 12.8693 1.80219 14.3342 3.11016C15.799 4.41812 16.622 6.19211 16.622 8.04185Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ZoomOut;
